@if (!isPDFReportPage()) {
  <geaui-page-layout [contentTemplate]="content" [headerTemplate]="header" [sidebarTemplate]="sidebar">
    <ng-template #header>
      @if (noAuth !== undefined) {
        <geaui-header
          [disableLoginMobile]="true"
          [disableSignupMobile]="true"
          [headerTitle]="headerTitle | translate"
          [noAuth]="noAuth"
          [showBanner]="false" />
      }
    </ng-template>
    <ng-template #content>
      @if ((!tokenReady || !userReady) && !loggedOutPageReady) {
        <div class="spinner">
          <p-progressSpinner animationDuration="2s" strokeWidth="4" />
        </div>
      } @else {
        <div class="content-body">
          <router-outlet />
        </div>
      }

      @if (isLoading$ | async) {
        <div class="overlay-spinner">
          <geaui-progress-spinner [size]="'large'" />
        </div>
      }
    </ng-template>
    <ng-template #sidebar>
      @if (!noAuth && tokenReady) {
        <!-- <CHANGE ME> - Change to Icon of your Choice -->
        <geaui-sidebar-v3
          [navigationItems]="navItems"
          [slimView]="true"
          [adminViewNavigationItems]="adminNavItems"
          [bottomNavigation]="botItems"
          [devisionName]="headerTitle | translate"
          [devisionIconPath]="environment.appContentStorageURL + 'core/asset/icons/24px_asset-app.svg'"
          devisionIconBackgroundColor="var(--geaui-night-blue)" />
      }
    </ng-template>
  </geaui-page-layout>
} @else {
  <router-outlet />
}
